import { Col, Form, Input, Select } from 'antd';
import React, { Component } from 'react';

class PricesAndQuantities extends Component {
  render() {
    return (
      <>
        <Col span={6}>
          <Form.Item
            name={['vhc_part_qaty_tota']}
            label="Tổng số lượng xe"
            rules={[{ required: true }]}
          >
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={['vhc_part_qaty_aval']}
            label="Số xe sẵn dùng"
            rules={[{ required: true }]}
          >
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            name={['vhc_part_defa_prie']}
            label="Giá cơ bản"
            rules={[{ required: true }]}
          >
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_2hours']} label="Giá 2h">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_4hours']} label="Giá 4h">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_8hours']} label="Giá 8h">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_12hours']} label="Giá 12h">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_24hours']} label="Giá 24h">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item name={['vhc_partner_price_week']} label="Giá tuần">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_2week']} label="Giá 2 tuần">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_month']} label="Giá tháng">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_quarter']} label="Giá quý">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_halfyear']} label="Giá nửa năm">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={['vhc_partner_price_year']} label="Giá năm">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
        <Col span={24} style={{ marginTop: 8 }}>
          <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 6 }}>
            Thông tin đặt cọc
          </div>
        </Col>
        <Col span={6}>
          <Form.Item label="Tiền đặt cọc">
            <div style={{ display: 'flex', gap: 8 }}>
              <Form.Item name={['vhc_deposit_amount']} noStyle>
                <Input onChange={this.props.onChange} />
              </Form.Item>
              <Form.Item name={['vhc_deposit_currency']} noStyle>
                <Select
                  options={[
                    { value: 'VND', label: 'VND' },
                    { value: 'USD', label: 'USD' },
                  ]}
                  style={{ width: 100 }}
                />
              </Form.Item>
            </div>
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item name={['deposit_alternative']} label="Tài sản thay thế">
            <Input onChange={this.props.onChange} />
          </Form.Item>
        </Col>
      </>
    );
  }
}

export default PricesAndQuantities;
